import { render, staticRenderFns } from "./cancellation-invoice.vue?vue&type=template&id=22824858"
import script from "./cancellation-invoice.vue?vue&type=script&lang=js"
export * from "./cancellation-invoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports